// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenShadow_wrapper__3Gl-k","fixed":"ScreenShadow_fixed__3OwKb"};